import { render, staticRenderFns } from "./modalRejectDocuments.vue?vue&type=template&id=f54166cc&scoped=true&"
import script from "./modalRejectDocuments.vue?vue&type=script&lang=js&"
export * from "./modalRejectDocuments.vue?vue&type=script&lang=js&"
import style0 from "./modalRejectDocuments.vue?vue&type=style&index=0&id=f54166cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54166cc",
  null
  
)

export default component.exports